
import LoginFlow from "@/mixins/login-flow";

export default LoginFlow.extend({
  name: "Login",
});
